<template>
    <ur-modal ref="modal" noFoot width="704px;"  :title="title">
        <div class="modal_body">
            <div class="tbl_list type2">
              <table>
                <colgroup>
                  <col style="width:167px">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">{{$t("MSG_TXT_EMAIL")}} </th>
                    <td>{{userInfo.userEmail}}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{$t("MSG_TXT_NAME")}}</th>
                    <td>{{userInfo.userName}}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{$t("MSG_TXT_USR_RGST_DT")}}</th>
                    <td> {{userInfo.firstRegistrationDTM}}</td>
                  </tr>
                </tbody>
              </table>
            </div>            
            <div class="tbl_list type2">
                <div v-if="modStatus"   class="modSpan">
                    <table>
                    <colgroup>
                    <col style="width:167px">
                    <col style="width:auto">
                    </colgroup>
                    <tbody>
                    <tr>
                        <th scope="row">{{$t("MSG_TXT_LEVEL")}}</th>
                        <td> <ur-dropdown ref="level" v-model="userInfo.levelId"  style="width: 200px;"  :items="dropdownItems" /></td>
                    </tr>
                    <tr>
                        <th scope="row">{{$t("MSG_BTN_ACTV")}}</th>
                        <td><ur-switch v-model="switchFlag" /></td>
                    </tr>
                    </tbody>
                    </table>
                </div>
                <div v-else class="detailSpan">
                    <table>
                        <caption>{{$t("MSG_TXT_SHOW_DETAIL")}}</caption>
                        <colgroup>
                        <col style="width:167px">
                        <col style="width:auto">
                        </colgroup>
                        <tbody>
                        <tr>
                            <th scope="row">{{$t("MSG_TXT_LEVEL")}}</th>
                            <td>{{userInfo.levelName}}</td>
                        </tr>
                        <tr>
                            <th scope="row">{{$t("MSG_BTN_ACTV")}}</th>
                            <td>
                                <div v-if="switchFlag">
                                    {{$t("MSG_TXT_ACTV")}}
                                </div>
                                <div v-else>
                                    {{$t("MSG_BTN_NON_ACTV")}}
                                </div>
                            </td>
                        </tr>
                        </tbody>   
                    </table>
                </div>
            </div>
        </div>
        <div class="modal_footer">
            <div v-if="modStatus"  class="modSpan">                                    
                <ur-button  @click="close">{{$t("MSG_BTN_CNCL")}}</ur-button>
                <ur-button solid main @click="modUserInfo">{{$t("MSG_BTN_SAVE")}}</ur-button>
            </div>
            <div v-else class="detailSpan">   
                <ur-button @click="changeFlag" >{{$t("MSG_BTN_MOD")}}</ur-button>
                <ur-button solid main @click="close">{{$t("MSG_BTN_CFRM")}}</ur-button>         
            </div>            
        </div>
    </ur-modal>
    
</template>
<script>
import ReplyCode from '~modules/AI/js/ReplyCode.js';

    export default {
        name: 'CMP_AIU_00002',
        props:{
            userInfo : {
                type : Object,
                default: null,
            },
            saasLevelList : {
                type : Array,
                default: () => [],
             },
            modStatus: {
                type: Boolean,
                default: false
            },
            switchFlag: {
                type: Boolean,
                default: false
            },
            /*
            title: {
                type: String,
                default: "계정상세보기"
            },
            */
        },
        data() {
            return {
                radioValue : false,
                userInfoAsk: {
                    loginId:'',
                    userAccountStateCode:'',
                    userId:'',
                    levelId:'',
                },
               /*  switchFlag:false, */
                validateRule: [
                    v=> !!v || 'required field'
                ]
            }
            
        },        
        computed:{            
            dropdownItems(){
                return this.saasLevelList;
            },
            title(){
                if(!this.modStatus) {
                    return '계정 상세';
                } else {
                    return '계정 수정';
                }
            },
            switch(){
                return this.switchFlag;
            },
                       
        },
        created(){
              
            
        },

        methods:{
            open() {                
                this.$refs['modal'].open();
                // if(this.userInfo.userAccountStateCode==='1'){
                //      this.switchFlag = true;
                // }else{
                //      this.switchFlag = false;
                // }
            },
            close() {
                this.$emit('getUserList');
                this.$refs['modal'].close();
            },
            modUserInfo(){
                if(!this.$refs['level'].isValid()){                    
                    return false;
                }
                this.userInfoAsk.userId = this.userInfo.userId;
                this.userInfoAsk.loginId = this.userInfo.loginId;
                this.userInfoAsk.levelId = this.userInfo.levelId;
                if(this.switchFlag){
                    this.userInfoAsk.userAccountStateCode="1";
                }else{
                    this.userInfoAsk.userAccountStateCode="0";
                }
                //this.userInfoAsk.userAccountStateCode = this.userInfo.userAccountStateCode;
                //console.log(this.userInfoAsk);
                
                http.request('PGE_AIU_00001', 'DTS_AIU_00003', {
                    data: this.userInfoAsk,
                }).then((response) => {
                    console.log(response.data);
                    if (response.data.reply.code === ReplyCode.NO_ERROR) {
                        this.$emit('onClose');
                        this.$refs['modal'].close();

                    } else if (response.data.reply.code === ReplyCode.USER_NOT_UPDATABLE) { // 수정하려는 계정이 해당 테넌트에 존재하는 유일한 활성화된 관리자인지 확인
                        this.$emit('onClose');
                        this.$refs['modal'].close();
                        utils.aiccMessageBox('확인', response.data.reply.korMsg, '확인');

                    }else{
                        this.userInfo.levelId ="";
                    }
                });
                
            },
            changeFlag(){
                //this.modStatus = true;
                this.$emit('changeStatus', true);
            }
        }
    }
</script>